<!--
 * @Description: 商品
 * @Date: 2023-09-06 17:43:16
 * @LastEditTime: 2023-09-06 18:52:59
-->

<template>
	<div style="display: inline-block; width: 100%">
		<!-- 替换展示框和搜索框的策略 -->
		<el-input
			class="selectClass"
			:placeholder="inputPlaceholder || $t('app.pleaseSelectUser')"
			v-model="lstUserName"
			v-popover:choseAgentPopover
			v-if="lstUserName && lstUserName != ''"
			readonly
		>
			<span class="el-input__suffix" slot="suffix">
				<span class="el-input__suffix-inner">
					<i
						class="el-select__caret el-input__icon el-icon-arrow-up"
						:class="{
							'is-reverse': showAgentDropDown
						}"
					></i>
				</span>
			</span>
		</el-input>
		<el-input
			class="selectClass"
			:placeholder="inputPlaceholder || $t('app.pleaseSelectUser')"
			v-model="filterText"
			v-popover:choseAgentPopover
			v-else
		>
			<span class="el-input__suffix" slot="suffix">
				<span class="el-input__suffix-inner">
					<i
						class="el-select__caret el-input__icon el-icon-arrow-down"
						:class="{
							'is-reverse': showAgentDropDown
						}"
					></i>
				</span>
			</span>
		</el-input>

		<el-popover
			placement="bottom-start"
			height="300"
			ref="choseAgentPopover"
			trigger="click"
			@show="showAgentDepartmentPopover"
			@hide="hideAgentDepartmentPopover"
			:visible-arrow="false"
		>
			<div>
				<!-- <el-input class="keyword-search" :placeholder="searchPlaceholder">
        </el-input> -->
				<el-tree
					:data="dataList"
					show-checkbox
					@check-change="handleCheckChange"
					node-key="id"
					height="100px"
					ref="warehouseTree"
					:filter-node-method="filterNode"
				>
				</el-tree>
			</div>
		</el-popover>
	</div>
</template>

<script>
import { queryIntroduceCustomIdResDto } from '@/api/ChannelManagement';
import LoginUserHelper from "@/util/LoginUserHelper";
export default {
	data() {
		return {
			filterAgentTextClass: '',
			agentTreeData: [],
			showAgentDropDown: false,
			lstUserName: '',
			lstUserId: [],
			radios: [],
			dataList: [],
			filterText: ''
		};
	},
	props: {
		isShowLabel: {
			type: Boolean,
			default: false
		},
		inputPlaceholder: {
			type: String,
			default: ''
		},
		isSingleChoice: {
			type: Boolean,
			default: false
		},
		doClear: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		filterText(val) {
			this.$refs.warehouseTree.filter(val);
		},
		doClear(newVal, oldVal) {
			this.clearSelect();
		}
	},
	methods: {
		filterNode(value, data) {
			if (!value) return true;
			return String(data.id).indexOf(value) !== -1 || data.label.indexOf(value) !== -1;
		},
		handleCheckChange(data) {
			console.log(data);
		},
		breakUpCode(val) {
			return val.split('_')[1];
		},
		traverse(val) {
			for (let item of val) {
				item.label = `${this.breakUpCode(item.value)}-${item.title}`;
				item.id = Number(this.breakUpCode(item.value));
				if (item.children) {
					traverse(item.children);
				}
			}
		},
		async initData() {
      const params = {
				param: {}
			};
			params.param.accountId = LoginUserHelper.getUserInfo().campusId;
			params.param.userId = LoginUserHelper.getUserInfo().id;
			let campusTree = await queryIntroduceCustomIdResDto(params);
			campusTree = campusTree.code === 0 ? campusTree.data : [];
			//构建结构
			// this.traverse(campusTree);
			campusTree = campusTree.map(obj => {
				const id = obj.introduceCustomId;
				const label = obj.introduceCustomName;
				return { id, label };
			});
			let tree = [];
			//如果没有内容就不显示全选
			if (campusTree && campusTree.length > 0) {
				tree = [
					{
						id: 0,
						label: this.$t('app.selectAll'),
						children: campusTree
					}
				];
			}
			this.dataList = tree;
		},
		showAgentDepartmentPopover() {
			this.showAgentDropDown = true;
		},
		hideAgentDepartmentPopover() {
			this.showAgentDropDown = false;
			this.lstUserId = []; //置空一下
			this.lstUserName = '';
			let selectPeopleName = [];
			let selectIdArr = this.$refs.warehouseTree.getCheckedKeys();
			selectIdArr = selectIdArr.filter(e => e !== 0); //把全选的节点去掉
			let selectNodeArr = this.$refs.warehouseTree.getCheckedNodes();
			selectNodeArr = selectNodeArr.filter(e => e.id !== 0); //把全选的节点去掉

			console.log(selectNodeArr);
			if (selectNodeArr.length > 0) {
				selectNodeArr.map(item => {
					selectPeopleName.push(item['label']);
				});
				this.lstUserName = selectPeopleName.join(',');
				this.lstUserId = selectIdArr;
				this.$emit('input', this.lstUserId); //必须在前面
				this.$emit('select', this.lstUserId);
				this.filterText = '';
			} else {
				this.lstUserName = '';
				this.lstUserId = [];
				this.filterText = '';
				this.$emit('input', []); //必须在前面
				this.$emit('select', []); //为了清空
			}
		},
		clearSelect() {
			this.$refs.warehouseTree.setCheckedNodes([]);
			this.lstUserName = '';
		}
	},
	mounted() {
		this.initData();
	}
};
</script>

<style lang="scss" scoped>
.is-reverse {
	transform: rotate(-180deg);
}
.selectClass {
	width: 100%;
	:deep(.el-input__inner) {
		height: 32px;
	}
}
:deep(.el-popover) {
	width: 100%;
}
</style>
